export { default } from "./BogosCarousel";
